import React, { useState, useEffect, useRef } from "react";
import Link from "../../components/Link";
import Media from "../../components/common/Media";
import { styled } from "../../stitches.config";
import { h2 } from "../commonStyles/Fonts";
import CategoryBadge from "../CategoryBadge";
import PlayerIconBackground from "../assets/icons/player-icon.svg";

interface IProps {
  article: any;
  media?: any;
  style?: string;
  withBackground?: boolean;
}

const PhotoOnTopLifestyle: React.FC<IProps> = ({
  media,
  article,
  style,
  withBackground,
  ...props
}) => {
  const imgUrl = article?.picture?.img;
  const [height, setHeight] = useState(200);
  const pictureContainer = useRef<HTMLDivElement>(null);
  const partner = (article.partner ? <Partner>{article.partner}</Partner> : null);
  useEffect(() => {
    if (pictureContainer?.current?.clientWidth) {
      const eltWidth = pictureContainer?.current?.clientWidth;
      const cHeight = Math.ceil((eltWidth * 472) / 840);

      if (cHeight !== height) {
        setHeight(cHeight);
      }

      // console.log('cHeight', height, cHeight, media);
    }
  }, []);

  return (
    <Wrapper
      className={`photo-on-top style--${(style ? style : '')} ${(withBackground ? " style--with-padding" : "")}`}
    >
      <Link to={article.settings?.link || article.url}>
        <StyledPhotoOnTop ref={pictureContainer} size={article.size}>
          <StyledImage size={article.size}>
            <Media
              media={media}
              src={imgUrl}
              preserveRatio={false}
              aspectRatio={1.5}
              height={height}
            />
            {partner}
            {article?.player && <PlayerIcon boxSize="xxl" />}
            {article?.category && article.category?.name && (
              <div className="category">
                <CategoryBadge
                  text={article.category.name}
                  sponsored
                  showMark
                  markText=""
                />
              </div>
            )}
          </StyledImage>
        </StyledPhotoOnTop>
        <StyledWrap>
          <Title className={h2()}>
            {article?.settings?.title_normal || article?.pile_title || article?.title}
          </Title>
          {article?.lead &&
            <Lead>
              {article?.lead}
            </Lead>
          }
        </StyledWrap>
      </Link>
    </Wrapper>
  );
};

const Partner = styled("span", {
  display: 'block',
  position: 'absolute',
  left: '0',
  top: '0',
  padding: '0px 8px',
  backgroundColor: '#D8D8D8',
  color: '#8B8B8B',
  lineHeight: '16px',
  fontSize: '11px',
  zIndex: '4',
});

const StyledPhotoOnTop = styled("div", {
  variants: {
    size: {
      lg: {
        "@bp4": {
          width: "455px",
          height: "330px",
        },
        "@bp5": {
          width: "624px",
          height: "416px",
        },
      },
      md: {
        "@bp4": {
          width: "200px",
          // height: "100px",
        },
        "@bp5": {
          width: "408px",
          height: "272px",
        },
      },
    },
  },
  "& a": {
    textDecoration: "none !important",
  },
});

const StyledImage = styled("div", {
  position: "relative",
  "& img": {
    width: "100%",
    height: "auto",
    display: "block",
  },
  variants: {
    size: {
      lg: {

      },
      md: {

      },
    },
  },
  "& .category": {
    position: "absolute",
    bottom: "16px",
    left: "16px",
    zIndex: "3",
  },
});

const StyledWrap = styled("div", {
  display: "block",
  color: "$grayscale100",
  padding: "40px 0 0 0",
  margin: "0 auto",
});
const WrapperAuthor = styled("div", {
  display: "flex",
  alignItems: "center",
  marginTop: "18px",
  p: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "12px",
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: "800",
    color: "$grayscale100",
  },
});

const Wrapper = styled("div", {
  marginBottom: "40px",

  "&.style--red": {
    [`${StyledWrap} > span`]: {
      backgroundColor: "#EA3A3E",
      color: "white",
      boxShadow: "2px 0 0 red, -2px 0 0 #EA3A3E",
    },
  },

  "&.style--primary": {
    [`${StyledWrap} > span`]: {
      backgroundColor: "$primary",
      color: "white",
      boxShadow: "2px 0 0 red, -2px 0 0 $primary",
    },
  },

  "&.style--black": {
    [`${StyledWrap} > span`]: {
      backgroundColor: "#131212",
      color: "white",
      boxShadow: "2px 0 0 #131212, -2px 0 0 #131212",
    },
  },

  "&.style--with-padding": {
    backgroundColor: "$grayscale0",
    paddingBottom: "1px",
    [`${StyledWrap}`]: {
      margin: "16px",
      padding: 0,
      "@bp4": {
        height: "70px",
        overflow: "hidden"
      },
    },
    [`${WrapperAuthor}`]: {
      margin: "15px 16px",
      padding: 0,
    }
  },
});

const PlayerIcon = styled("div", {
  position: "absolute",
  zIndex: 100,
  backgroundImage: `url("${PlayerIconBackground}")`,
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",

  top: "50%",
  left: "50%",
  width: "48px",
  height: "48px",
  marginLeft: "-24px",
  marginTop: "-24px",

  variants: {
    boxSize: {
      xxl: {
        backgroundSize: "48px",
      },
      xs: {
        backgroundSize: "32px",
      },
      xxs: {
        backgroundSize: "28px",
      },
    },
  },
});

const Title = styled("p", {
  overflow: "hidden",
  maxHeight: "135px",
  margin: "0",
});

const Lead = styled("p", {
  "& span": {
    textDecoration: "none",
  },
  padding: 0,
  margin: "8px 0 0 0",
  fontWeight: "600",
  fontFamily: "$grotesk",
  lineHeight: "24px",
  maxHeight: "72px",
  overflow: "hidden",
});

export default PhotoOnTopLifestyle;
